module.exports = __webpack_public_path__ + "img/video.2f9feeb6.png";